import {
    getVehicleInfoByLorryType,
    LORRY_CATEGORIES_ENUM,
    NEW_LORRY_CAPACITY
} from "@vahak/core/dist/constants/lorryTypes";
import * as Yup from "yup";
import { lorryCreationFormFieldNames } from "../constants";

/**
 * We have not added hardcore validations like if the container is a 32 ft sxl then
 * capacity can only be 7,8,9 tonne because we don't have an open field.
 *
 * Backend validations should be there.
 *
 *
 * rcDocument is disabled as in app its not mandatory field
 */

const isLoadForm = (option: any) => {
    return option?.parent?.formSource === "load";
};

export const lorryValidationSchema = {
    [lorryCreationFormFieldNames.rcDocument]: Yup.mixed().when("isRcUploadRequired", {
        is: true,
        then: (schema) => schema.required("Required"),
        otherwise: (schema) => schema.notRequired()
    }),
    [lorryCreationFormFieldNames.lorryType]: Yup.number().positive("Lorry type is required!"),
    [lorryCreationFormFieldNames.lorryCapacity]: Yup.number().when(
        [
            lorryCreationFormFieldNames.lorryType,
            lorryCreationFormFieldNames.allowedCapacityMin!,
            lorryCreationFormFieldNames.allowedCapacityMax!,
            lorryCreationFormFieldNames.allowedVehicleList!
        ],
        ([lorryType, allowedCapacityMin, allowedCapacityMax, allowedVehicleList]: any[], schema: any) => {
            const selectedLorry = getVehicleInfoByLorryType(lorryType, "lorry", {
                srcList: allowedVehicleList
            });
            // Admin/CS new-user restriction sets allowedCapacity*; always intersect with those bounds.
            const requiredMin = allowedCapacityMin ?? NEW_LORRY_CAPACITY.LORRY_POST.min;
            const requiredMax = allowedCapacityMax ?? NEW_LORRY_CAPACITY.LORRY_POST.max;
            const min = Math.max(selectedLorry?.capacity?.min ?? requiredMin, requiredMin);
            const max = Math.min(selectedLorry?.capacity?.max ?? requiredMax, requiredMax);
            const rangeText = `${min}-${max}`;

            return schema.when(lorryCreationFormFieldNames.isLorryCapacityRequired, {
                is: true,
                then: () => {
                    if (min > max) {
                        return Yup.number()
                            .typeError("Please enter a valid number")
                            .test("capacity-not-supported", "This vehicle capacity is not supported", () => false)
                            .required("Lorry Capacity is required field");
                    }

                    return Yup.number()
                        .typeError("Please enter a valid number")
                        .min(min, `Invalid capacity (Range: ${rangeText})`)
                        .max(max, `Invalid capacity (Range: ${rangeText})`)
                        .required("Lorry Capacity is required field");
                },
                otherwise: () => Yup.number().nullable()
            });
        }
    ),

    // [lorryCreationFormFieldNames.lorryCapacity]: Yup.number().when(
    //     [
    //         lorryCreationFormFieldNames.lorryType,
    //         lorryCreationFormFieldNames.lorryTyres,
    //         lorryCreationFormFieldNames.lorrySize,
    //         lorryCreationFormFieldNames.sizeText
    //     ],
    //     (...args: any) => {
    //         const [lorryType, lorryTyres, lorrySize, lorrySizeText, _, option] = args;
    //         /**
    //          * Lorry Capacity is present in all except in Trailer
    //          */

    //         const selectedLorry = _NEW_LORRY_TYPES.filter((x) => x.id === lorryType)[0];

    //         const isTruck = lorryType === LORRY_CATEGORIES_ENUM.TRUCK;
    //         const isContainer = lorryType === LORRY_CATEGORIES_ENUM.CONTAINER;
    //         const isTrailer = lorryType === LORRY_CATEGORIES_ENUM.TRAILER;
    //         const isLcv = lorryType === LORRY_CATEGORIES_ENUM.LCV;
    //         const isHyva = lorryType === LORRY_CATEGORIES_ENUM.HYVA;
    //         const isTanker = lorryType === LORRY_CATEGORIES_ENUM.TANKER;

    //         let selectedLorryCapacity;
    //         let selectedLorryCapacityText = selectedLorry ? selectedLorry.capacityText : undefined;

    //         if (isTruck) {
    //             const lorry = selectedLorry?.tyreWithCapacity?.find((x) => x.id === lorryTyres);
    //             selectedLorryCapacity = lorry?.capacity;
    //             selectedLorryCapacityText = lorry?.capacityText;
    //         } else if (isContainer) {
    //             const lorry = selectedLorry?.bodyTypeWithCapacity?.find(
    //                 (x) => x.id === getContainerSizeEnum(lorrySize, lorrySizeText)
    //             );
    //             selectedLorryCapacity = lorry?.capacity;
    //             selectedLorryCapacityText = lorry?.capacityText;
    //         } else if (isTrailer) {
    //             const lorry = selectedLorry?.bodyTypeWithCapacity?.find(
    //                 (x) => x.id === getTrailerBodyEnum(lorrySize, lorrySizeText)
    //             );
    //             selectedLorryCapacity = lorry?.capacity;
    //             selectedLorryCapacityText = lorry?.capacityText;
    //         } else if (isLcv) {
    //             const lorry = selectedLorry?.bodyTypeWithCapacity?.find((x) => x.id === getLcvSizeEnum(lorrySize));
    //             selectedLorryCapacity = lorry?.capacity;
    //             selectedLorryCapacityText = lorry?.capacityText;
    //         } else if (isHyva) {
    //             const lorry = selectedLorry?.tyreWithCapacity?.find((x) => x.id === lorryTyres);
    //             selectedLorryCapacity = lorry?.capacity;
    //             selectedLorryCapacityText = lorry?.capacityText;
    //         } else if (isTanker) {
    //             const lorry = selectedLorry?.tyreWithCapacity?.find((x) => x.id === lorryTyres);
    //             selectedLorryCapacity = lorry?.capacity;
    //             selectedLorryCapacityText = lorry?.capacityText;
    //         }

    //         if (lorryType !== LORRY_CATEGORIES_ENUM.TRAILER)
    //             return Yup.number().when([lorryCreationFormFieldNames.isLorryCapacityRequired], {
    //                 is: true,
    //                 then: selectedLorryCapacity
    //                     ? Yup.number()
    //                           .typeError("Please enter a valid number")
    //                           .min(selectedLorryCapacity.min, `Invalid capacity (Range: ${selectedLorryCapacityText})`)
    //                           .max(selectedLorryCapacity.max, `Invalid capacity (Range: ${selectedLorryCapacityText})`)
    //                           .required("Lorry Capacity is required field")
    //                     : Yup.number()
    //                           .typeError("Please enter a valid number")
    //                           .min(1, `Lorry Capacity can't be less than 1`)
    //                           .max(100, `Lorry Capacity can't be more than 100`)
    //                           .required("Lorry Capacity is required field")
    //             });
    //         else
    //             return Yup.number().when([lorryCreationFormFieldNames.isLorryCapacityRequired], {
    //                 is: true,
    //                 then: selectedLorryCapacity
    //                     ? Yup.number()
    //                           .typeError("Please enter a valid number")
    //                           .min(selectedLorryCapacity.min, `Invalid capacity (Range: ${selectedLorryCapacityText})`)
    //                           .max(selectedLorryCapacity.max, `Invalid capacity (Range: ${selectedLorryCapacityText})`)
    //                           .required("Lorry Capacity is required field")
    //                     : Yup.number()
    //                           .typeError("Please enter a valid number")
    //                           .min(1, `Lorry Capacity can't be less than 1`)
    //                           .max(100, `Lorry Capacity can't be more than 100`)
    //                           .required("Lorry Capacity is required field")
    //             });
    //     }
    // ),
    [lorryCreationFormFieldNames.lorryTyres]: Yup.number().when(
        [lorryCreationFormFieldNames.lorryType],
        (values, schema) => {
            const [lorryType] = values;
            /**
             * Lorry Tyres are only present in Truck, Hyva and Tanker (not LCV).
             */
            if (
                lorryType === LORRY_CATEGORIES_ENUM.TRUCK ||
                lorryType === LORRY_CATEGORIES_ENUM.HYVA ||
                lorryType === LORRY_CATEGORIES_ENUM.TANKER
            )
                return schema.positive("Tyres should be present");
            else return schema;
        }
    ),
    [lorryCreationFormFieldNames.lorrySize]: Yup.number().when(
        [
            lorryCreationFormFieldNames.lorryType,
            lorryCreationFormFieldNames.lorryTyres,
            lorryCreationFormFieldNames.lorryCapacity,
            lorryCreationFormFieldNames.lorrySizeNoPreference
        ],
        (values, schema) => {
            const [lorryType, lorryTyres, lorryCapacity, lorrySizeNoPreference] = values;
            const vehicleInfo = getVehicleInfoByLorryType(lorryType, "lorry");
            const isTruckSizeAvailable = !!vehicleInfo?.getSizeOptionsByTyre?.(lorryTyres)?.length;
            const isLcvSizeAvailable = !!vehicleInfo?.getSizeOptionsByCapacity?.(Number(lorryCapacity))?.length;

            if (lorryType === LORRY_CATEGORIES_ENUM.TRUCK && isTruckSizeAvailable) {
                return schema.positive("Lorry Size should be present");
            } else if (lorryType === LORRY_CATEGORIES_ENUM.LCV && isLcvSizeAvailable && !lorrySizeNoPreference) {
                return schema.positive("Lorry Size should be present");
            } else if (lorryType === LORRY_CATEGORIES_ENUM.CONTAINER || lorryType === LORRY_CATEGORIES_ENUM.TRAILER) {
                return schema.positive("Lorry Size should be present");
            } else return schema;
        }
    ),
    [lorryCreationFormFieldNames.lorryBodyType]: Yup.number().when(
        lorryCreationFormFieldNames.lorryType,
        (values: any, schema) => {
            const lorryType = values as LORRY_CATEGORIES_ENUM;

            const selectedLorry = getVehicleInfoByLorryType(lorryType, "lorry");

            const allowedTypes = [LORRY_CATEGORIES_ENUM.LCV, LORRY_CATEGORIES_ENUM.TRUCK, LORRY_CATEGORIES_ENUM.TANKER];

            if (!allowedTypes.includes(lorryType)) {
                return schema.nullable();
            }

            return schema
                .typeError("Please enter a valid number")
                .test("valid-body-type", "Invalid body type", (value) => {
                    return !!selectedLorry?.bodyOptions?.some((body) => body.id === value);
                });
        }
    ),
    [lorryCreationFormFieldNames.sizeText]: Yup.string().when(
        [
            lorryCreationFormFieldNames.lorryType,
            lorryCreationFormFieldNames.lorryTyres,
            lorryCreationFormFieldNames.lorryCapacity,
            lorryCreationFormFieldNames.lorrySizeNoPreference
        ],
        (values: any[], schema) => {
            const [lorryType, lorryTyres, lorryCapacity, lorrySizeNoPreference] = values as [
                LORRY_CATEGORIES_ENUM,
                number,
                number,
                boolean
            ];

            const vehicleInfo = getVehicleInfoByLorryType(lorryType, "lorry");
            const isTruckSizeAvailable = !!vehicleInfo?.getSizeOptionsByTyre?.(lorryTyres)?.length;
            const isLcvSizeAvailable = !!vehicleInfo?.getSizeOptionsByCapacity?.(Number(lorryCapacity))?.length;

            const shouldRequireSize =
                lorryType === LORRY_CATEGORIES_ENUM.CONTAINER ||
                lorryType === LORRY_CATEGORIES_ENUM.TRAILER ||
                (lorryType === LORRY_CATEGORIES_ENUM.TRUCK && isTruckSizeAvailable) ||
                (lorryType === LORRY_CATEGORIES_ENUM.LCV && isLcvSizeAvailable && !lorrySizeNoPreference);

            return shouldRequireSize ? schema.required("Size text is required") : schema.notRequired();
        }
    )
};

export const lorryTypeValidation = Yup.object().shape({
    ...lorryValidationSchema
});
